import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export interface ProductSwatchCarouselSkeletonProps {
  className?: string;
}

export const ProductSwatchCarouselSkeleton = ({ className }: ProductSwatchCarouselSkeletonProps) => {
  return (
    <Container className={className}>
      {Array.from({ length: 4 }).map((_, idx) => {
        return <Skeleton key={idx} />;
      })}
    </Container>
  );
};

const Container = styled.div`
  padding: 0 16px;
  display: flex;
  gap: 2px;
  width: 100%;
`;

const Skeleton = styled.div`
  position: relative;
  width: 48px;
  height: 58px;
  background: ${vars.color.fillSecondary};
  border-radius: 2px;
  overflow: hidden;
`;
